export default "__VITE_ASSET__Cs31cDLm__"